import { hoc } from '#packages/util';

import type { StateMapperArgs } from 'types/redux';

const mapStateToProps = ({ editorAPI }: StateMapperArgs) => {
  return { openWixSEOWiz: editorAPI.account.openWixSEOWiz };
};

export const withConnect = hoc.connect(hoc.STORES.EDITOR_API, mapStateToProps);
